import { Service } from 'types/service';
import { CheckoutData, CheckoutForm } from './CheckoutForm';
import { HTTP } from 'utils/http';
import { useListServices } from 'hooks/useApiQueries';

export interface ServiceCheckoutProps {
  product: Service;
}
export function ServiceCheckout({ product }: ServiceCheckoutProps) {
  const { refetch: refetchServices } = useListServices();

  async function onPurchase(Payment: CheckoutData, Test?: boolean): Promise<Record<string, unknown>> {
    if (Payment.PaymentMethod === 'Alma') {
      const response = await HTTP.post('/sale/processalmapayment', { ServiceId: product.Id, Payment, Test }).send();
      return response as Record<string, unknown>; // Return the response
    } else {
      const response = await HTTP.post('/sale/services', { ServiceId: product.Id, Payment, Test }).send();
      await refetchServices();
      return response as Record<string, unknown>; // Return the response
    }
  }
  return <CheckoutForm onPurchase={onPurchase} amount={product.Price} />;
}
